import React from "react";
import type { FunctionComponent } from "react";

const BalanceStatusSuccessIcon: FunctionComponent = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#01B163" />
      <path d="M7 12.26L10.7135 16.1338L16.808 7.31403" stroke="white" strokeWidth="2.45753" strokeLinejoin="round" />
    </svg>
  );
};

export default BalanceStatusSuccessIcon;
